<template>
    <div class="sign-coach-schedule-components">
        <el-dialog
            :visible.sync="visible"

            :title="''+$t('Message.tip_title')"
            left>

            <el-form
                ref="form"

                :model="form"
                :rules="rules"


                class="brand-list-form"
               >

                <el-form-item       >
                    <span style="width: 200px" class="formLabel">{{$t('Message.tip_code_sign')}}</span>
                </el-form-item>

                    <el-form-item     >
                        <span  style="width: 60px;" prop="PhoneCode" >{{$t('Common.phone_number')}}：</span>
                        <span style="width: 100px">{{form.clientPhone}}</span>

                    </el-form-item>



                <el-form-item >

                    <el-input
                        maxlength="6"
                        :placeholder="$t('Fill.code')"
                        style="width: 180px;"
                        type="text"
                        v-model="form.PhoneCode" />
                    <el-button style="width: 100px;margin-left: 20px"  @click="handleCode">
                        {{ list.old.msg }}
                    </el-button>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeForm" >{{ $t('Common.cancel') }}</el-button>
                <el-button @click="handleSignin" type="primary">{{ $t('Message.confirm') }}</el-button>



             </span>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog, Form } from 'element-ui';
import {mapState} from "vuex";

export default {
    name: 'signCoachSchedule',
    components: {
        ElDialog: Dialog,
        ElForm: Form,
    },
    data() {
        return {
            visible: false,
            form: {



                id: null,
                clientPhone:'',
                PhoneCode: '',

            },
            rules: {
                PhoneCode: { required: true, message: this.$t('Fill.code') },
            },
            list: {
                old: {
                    timer: null,
                    second: 60,
                    msg: this.$t('Staff.Modify.handle_code'),
                },
                new: {
                    timer: null,
                    second: 60,
                    msg: this.$t('Staff.Modify.handle_code'),
                },
            },
        };
    },
    computed: {
        ...mapState([
            'my',
        ]),
    },
    methods: {
        open(id) {
            this.id = id;
            this.fetchData();
            this.visible = true;
        },
        fetchData() {
            API.get(`lesson/coach/schedule/${this.id}`).then(res => {
                this.form = res;
            });
        },


        handleCode() {
            const type='old';
            if (this.list['old'].timer) return false;
            const url =  'sms/send-sign' ;
            const postform={
                phone:this.form.clientPhone,
            };
            const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0-3]{1})|(15[0-3]{1})|(15[5-9]{1})|(18[0-9]{1}))+\d{8})$/;

            API.post(url, postform).then(res => {
                $ele.$message.success(this.$t('Staff.Modify.code_success'));
                this.list[type].timer = setInterval(() => {
                    if (this.list[type].second) {
                        this.list[type].second--;
                        this.list[type].msg= `${this.list[type].second}${this.$t('Staff.Modify.refresh')}`;
                        return;
                    }
                    clearInterval(this.list[type].timer);
                    // timer 重置
                    this.list[type].timer = null;
                    this.list[type].second = 60;
                    this.list[type].msg= this.$t('Staff.Modify.again');
                }, 1000);
            });
        },

        closeForm(){
          this.visible=false;
        },
        // 签到
        handleSignin() {
                    const form={
                        phone:this.form.clientPhone,
                        code:this.form.PhoneCode,
                    };
                    API.post(`/lesson/coach/schedule/${this.id}/sign`,form)
                        .then(() => {
                            $ele.$message.success(this.$t('Message.success_sign'));
                          //  this.fetchData();
                            this.visible=false;
                        });

        },
    },
};
</script>

<style lang="scss">

.sign-coach-schedule-components {

    .el-form-item__label {
        display: none;
        width: 0px !important;
    }
    .formStar{
        font-family:"PingFangSC-Semibold","PingFang SC Semibold","PingFang SC",
        sans-serif;
        font-weight: 200;
        font-style: normal;
        font-size: 12px;
        color: #fb0404;
        padding: 5px;
    }
    .formLabel{
        font-size: 15px;
        font-weight: 200;
        line-height: 30px;
    }

    .label-style{
        font-size: 80px;

    }
    .label-content .el-form-item__content{
        font-size: 40px;
        color: #aaaa33;
    }
    .el-dialog {
        width: 480px;
        padding-bottom: 20px;
    }
    .el-dialog__body {
        margin-left: 30px;

    }
    .edit-coach-button {
        display: inline-block;
        position: relative;
        left: 50%;
        transform: translateX(calc(-50% - 15px));
    }
}
</style>
